import axios from "axios";

import { setLinkTag, generateStateToken } from "./utils/helpers";

// Sidebar
import CompanyappSidebar from "./partials/companyapp/sidebar";
import RHGSidebar from "./partials/rhg/sidebar";
import EquansSidebar from "./partials/equans/sidebar";
import RevoHSidebar from "./partials/revo-h/sidebar";

// LOGO
import rhgLogo from "./assets/rhg-logo.svg";
import companyappLogo from "./assets/ca-logo-pwa.png";
import equansLogo from "./assets/equans-logo.svg";
import revoLogo from "./assets/clients/revo-h/rhg_logo-schwarz-2.svg";

axios.defaults.withCredentials = true;
export const deepLinks = [
  "caequans://",
  "companyapp://",
  "communicator://",
  "radisson://",
  "revo-h://",
];

let client_id,
  pageTitle,
  serverUrl,
  filesystem,
  filesystem_root,
  subdomain,
  proxy,
  favoritesEnabled,
  permissionsEnabled,
  themesEnabled,
  appConfigEnabled,
  notificationsEnabled,
  presenterTaxonomies,
  advancedHeaderMenu,
  searchEnabled,
  editProfileEnabled,
  mediaLibraryEnabled,
  presenterNotesEnabled,
  presenterAudioEnabled,
  firebaseEnabled,
  userProfilePictureEnabled,
  counterEnabled,
  icePortalEnabled,
  sitaEnabled,
  referenceEnabled,
  pushNotificationsEnabled,
  shareEnabled,
  registrationEnabled = false;

const hostname = window?.location?.hostname || "";
let detectedClient = "companyapp";
let isDevEnv = false;

if (hostname === "localhost") {
  isDevEnv = true;
  const params = new URLSearchParams(window.location.search);
  const clientParam = params.get("client");
  if (clientParam) {
    detectedClient = clientParam;
  }
} else {
  // Determine dev environment from "dev-" prefix
  if (hostname.startsWith("dev-") || hostname.startsWith("dev.")) {
    isDevEnv = true;
  }

  if (hostname.includes("radisson")) {
    detectedClient = "radisson";
  } else if (hostname.includes("revo-h")) {
    detectedClient = "revo-h";
  } else if (hostname.includes("equans")) {
    detectedClient = "equans";
  } else if (hostname.includes("app")) {
    detectedClient = "companyapp";
  }
}

export const client = detectedClient;

switch (client) {
  case "companyapp":
    pageTitle = "Companyapp";
    serverUrl = isDevEnv
      ? "https://dev-cms.companyapp.net"
      : "https://cms.companyapp.net";
    filesystem_root = isDevEnv
      ? "https://dev-files.companyapp.net"
      : "https://files-app.companyapp.net";
    filesystem = isDevEnv
      ? "/var/www/dev-files.companyapp.net"
      : "/srv/production/assets/companyapp";
    subdomain = isDevEnv ? "dev-cms" : "cms";
    proxy = isDevEnv
      ? "https://dev-app.companyapp.net"
      : "https://app.companyapp.net";
    favoritesEnabled = true;
    permissionsEnabled = true;
    themesEnabled = true;
    appConfigEnabled = true;
    notificationsEnabled = true;
    presenterTaxonomies = true;
    advancedHeaderMenu = true;
    searchEnabled = true;
    editProfileEnabled = true;
    mediaLibraryEnabled = true;
    presenterNotesEnabled = true;
    presenterAudioEnabled = true;
    firebaseEnabled = true;
    userProfilePictureEnabled = true;
    counterEnabled = true;
    icePortalEnabled = false;
    sitaEnabled = false;
    referenceEnabled = true;
    pushNotificationsEnabled = true;
    shareEnabled = true;
    registrationEnabled = true;
    break;
  case "radisson":
    pageTitle = "Radisson";
    serverUrl = isDevEnv
      ? "https://dev-cms-radisson.companyapp.net"
      : "https://cms-radisson.companyapp.net";
    filesystem_root = isDevEnv
      ? "https://dev-files.companyapp.net"
      : "https://files-radisson.companyapp.net";
    filesystem = isDevEnv
      ? "/var/www/dev-files.companyapp.net"
      : "/srv/production/assets/radisson";
    subdomain = isDevEnv ? "dev-cms-radisson" : "cms-radisson";
    proxy = isDevEnv
      ? "https://dev-radisson.companyapp.net"
      : "https://radisson.companyapp.net";
    favoritesEnabled = true;
    permissionsEnabled = true;
    themesEnabled = true;
    appConfigEnabled = true;
    notificationsEnabled = true;
    presenterTaxonomies = true;
    advancedHeaderMenu = true;
    searchEnabled = false;
    editProfileEnabled = true;
    mediaLibraryEnabled = true;
    presenterNotesEnabled = true;
    presenterAudioEnabled = true;
    firebaseEnabled = true;
    userProfilePictureEnabled = false;
    counterEnabled = false;
    icePortalEnabled = true;
    sitaEnabled = true;
    referenceEnabled = false;
    pushNotificationsEnabled = false;
    shareEnabled = false;
    break;
  case "equans":
    client_id = "neU5wDzCBgDXps2IaSWePVty7teoO8C4yb6_FDZ2Z_k";
    pageTitle = "EQUANS UK";
    serverUrl = isDevEnv
      ? "https://equans.companyapp.net"
      : "https://app2.equans.co.uk";
    filesystem_root = null;
    filesystem = null;
    subdomain = null;
    proxy = null;
    favoritesEnabled = true;
    permissionsEnabled = false;
    themesEnabled = false;
    appConfigEnabled = false;
    notificationsEnabled = false;
    presenterTaxonomies = false;
    advancedHeaderMenu = false;
    searchEnabled = true;
    editProfileEnabled = true;
    mediaLibraryEnabled = false;
    presenterNotesEnabled = false;
    presenterAudioEnabled = false;
    firebaseEnabled = true;
    userProfilePictureEnabled = false;
    counterEnabled = false;
    icePortalEnabled = false;
    sitaEnabled = false;
    referenceEnabled = false;
    pushNotificationsEnabled = false;
    shareEnabled = false;
    break;
  case "revo-h":
    client_id = "U5wHjxU2Sl1e2P8yHISVS_--5KplMBwD-iR7kfioZWU";
    pageTitle = "REVO Hospitality Group";
    serverUrl = isDevEnv
      ? "https://dev-cms-revo-h.companyapp.net"
      : "https://cms-revo-h.companyapp.net";
    filesystem_root = isDevEnv
      ? "https://dev-files.companyapp.net"
      : "https://files-revo-h.companyapp.net";
    filesystem = isDevEnv
      ? "/var/www/dev-files.companyapp.net"
      : "/srv/production/assets/revo";
    subdomain = isDevEnv ? "dev-cms-revo-h" : "cms-revo-h";
    proxy = isDevEnv
      ? "https://dev-revo-h.companyapp.net"
      : "https://revo-h.companyapp.net";
    favoritesEnabled = true;
    permissionsEnabled = true;
    themesEnabled = true;
    appConfigEnabled = true;
    notificationsEnabled = false;
    presenterTaxonomies = true;
    advancedHeaderMenu = true;
    searchEnabled = true;
    editProfileEnabled = true;
    mediaLibraryEnabled = true;
    presenterNotesEnabled = false;
    presenterAudioEnabled = false;
    firebaseEnabled = true;
    userProfilePictureEnabled = false;
    counterEnabled = true;
    icePortalEnabled = false;
    sitaEnabled = false;
    referenceEnabled = true;
    pushNotificationsEnabled = false;
    shareEnabled = false;
    break;
  default:
    pageTitle = "Companyapp";
    serverUrl = "https://dev-cms.companyapp.net";
    filesystem_root = "https://dev-files.companyapp.net";
    filesystem = "/var/www/dev-files.companyapp.net";
    subdomain = "dev-cms";
    proxy = "https://dev-app.companyapp.net";
    favoritesEnabled = true;
    permissionsEnabled = true;
    themesEnabled = true;
    appConfigEnabled = true;
    notificationsEnabled = true;
    presenterTaxonomies = true;
    advancedHeaderMenu = true;
    searchEnabled = true;
    editProfileEnabled = true;
    mediaLibraryEnabled = true;
    presenterNotesEnabled = true;
    presenterAudioEnabled = true;
    firebaseEnabled = true;
    userProfilePictureEnabled = true;
    counterEnabled = true;
    icePortalEnabled = false;
    sitaEnabled = false;
    referenceEnabled = true;
    pushNotificationsEnabled = true;
    shareEnabled = true;
    break;
}

export const globalThemeDirectory = `${filesystem_root}/${subdomain}/themes/presenter_global_theme`;
export const globalThemeStylesheet = `${globalThemeDirectory}/dist/css/main.css`;
export const isSso =
  client === "companyapp" ? false : true;
export const root_auth_handshake = "drupalAuth";

if (isDevEnv && client !== "companyapp") {
  firebaseEnabled = false;
}

export {
  client_id,
  pageTitle,
  serverUrl,
  filesystem,
  filesystem_root,
  subdomain,
  proxy,
  favoritesEnabled,
  permissionsEnabled,
  themesEnabled,
  appConfigEnabled,
  notificationsEnabled,
  presenterTaxonomies,
  advancedHeaderMenu,
  searchEnabled,
  editProfileEnabled,
  mediaLibraryEnabled,
  presenterNotesEnabled,
  presenterAudioEnabled,
  firebaseEnabled,
  userProfilePictureEnabled,
  counterEnabled,
  icePortalEnabled,
  sitaEnabled,
  referenceEnabled,
  pushNotificationsEnabled,
  shareEnabled,
  registrationEnabled,
  isDevEnv,
};

// Set icons & manifest
setLinkTag("apple-touch-icon", `${client}/apple-touch-icon.png`, {
  sizes: "180x180",
});
setLinkTag("icon", `${client}/favicon-32x32.png`, {
  type: "image/png",
  sizes: "32x32",
});
setLinkTag("icon", `${client}/favicon-16x16.png`, {
  type: "image/png",
  sizes: "16x16",
});
setLinkTag("apple-touch-icon", `${client}/logo192.png`);
setLinkTag("manifest", `${client}/manifest.json`, {
  crossorigin: "use-credentials",
});

export const firebaseConfig = () => {
  switch (client) {
    case "equans":
      return {
        apiKey: "AIzaSyA-IdPblQ1kH0fbq1bSMsuQGMf6PtGdto8",
        authDomain: "equans-uk.firebaseapp.com",
        databaseURL:
          "https://equans-uk-default-rtdb.europe-west1.firebasedatabase.app",
        projectId: "equans-uk",
        storageBucket: "equans-uk.appspot.com",
        messagingSenderId: "440390820819",
        appId: "1:440390820819:web:578119b2d18282b1794526",
        measurementId: "G-EC524QL20H",
      };

    case "companyapp":
      return {
        apiKey: "AIzaSyCYmqVsdlTWGTrTcHNKRKkpoIrs7tFbnwE",
        authDomain: "companyapp-8be72.firebaseapp.com",
        databaseURL:
          "https://companyapp-8be72-default-rtdb.europe-west1.firebasedatabase.app",
        projectId: "companyapp-8be72",
        storageBucket: "companyapp-8be72.firebasestorage.app",
        messagingSenderId: "761719685927",
        appId: "1:761719685927:web:8cd08ee183c8ae718e1f02",
        measurementId: "G-532RXKSN6W",
        vapidKey: 'BMsy_oMEVePvslxF3-WRzorV7YRSBFHMB2tDXAcALz220SQnsDLJos611ffOsVGK_YjcYm4XCoajeHJMKlpbTdU',
      };

    case "revo-h":
      return {
        apiKey: "AIzaSyAIpuaWTVE4k4evyKQsJflAA3bNvTKUQ5g",
        authDomain: "revo-d8878.firebaseapp.com",
        databaseURL:
          "https://revo-d8878-default-rtdb.europe-west1.firebasedatabase.app",
        projectId: "revo-d8878",
        storageBucket: "revo-d8878.firebasestorage.app",
        messagingSenderId: "446435761446",
        appId: "1:446435761446:web:b2b90f34b4312bf83935e7",
        measurementId: "G-7B2XZVNBRE",
      };

    case "radisson":
      return {
        apiKey: "AIzaSyCDMf-VEyvAj06nRsCsiKPV2ip97HB6hMc",
        authDomain: "radisson-a4dca.firebaseapp.com",
        databaseURL:
          "https://radisson-a4dca-default-rtdb.europe-west1.firebasedatabase.app",
        projectId: "radisson-a4dca",
        storageBucket: "radisson-a4dca.firebasestorage.app",
        messagingSenderId: "450286346163",
        appId: "1:450286346163:web:3eff88b64e9099d4a735c6",
        measurementId: "G-GH1RH2BD6E",
      };

    default:
      return null;
  }
};

export const AppLogo = () => {
  if (client !== "companyapp") {
    if (client === "radisson") {
      return <img src={rhgLogo} alt="radisson hotel group logo" />;
    }

    if (client === "revo-h") {
      return (
        <img
          src={revoLogo}
          className="revo-h-logo"
          alt="revo hospitality logo"
        />
      );
    }

    if (client === "equans") {
      return <img src={equansLogo} alt="EQUANS logo" />;
    }
  } else {
    return <img src={companyappLogo} alt="companyapp logo" />;
  }
};

export const Sidebar = ({ showNavigation, isMobile, sidebarVisibility }) => {
  if (client !== "companyapp") {
    if (client === "radisson") {
      return (
        <RHGSidebar
          showNavigation={showNavigation}
          isMobile={isMobile}
          sidebarVisibility={sidebarVisibility}
        />
      );
    }

    if (client === "equans") {
      return (
        <EquansSidebar
          showNavigation={showNavigation}
          isMobile={isMobile}
          sidebarVisibility={sidebarVisibility}
        />
      );
    }

    if (client === "revo-h") {
      return (
        <RevoHSidebar
          showNavigation={showNavigation}
          isMobile={isMobile}
          sidebarVisibility={sidebarVisibility}
        />
      );
    }
  } else {
    return (
      <CompanyappSidebar
        showNavigation={showNavigation}
        isMobile={isMobile}
        sidebarVisibility={sidebarVisibility}
      />
    );
  }
};

export const oAuthConfig = () => {
  let scopes;

  if (client === 'equans') {
    scopes = 'openid email profile authenticated subeditor editor administrator';
  } else {
    scopes = 'openid email profile authenticated content_editor administrator presentation_manager presentation_user presentation_viewer';
  }
  

  return {
    client_id: client_id,
    url: `${serverUrl}/oauth/authorize`,
    redirect_uri: `${window.location.origin}/login/callback`,
    state: generateStateToken(),
    scope: scopes,
  };
};

const endpoints = () => {
  let resources = {
    home: "api/v2/app_home",
    home2: "api/v2/feed",
    categories: "api/v2/taxonomies/",
    company_directory: "api/v2/company_directory",
    contacts: "api/v2/users",
    documents: "api/v2/documents",
    documentCategories: "api/v2/taxonomies/document_categories",
    events: "api/v2/events",
    forms: "api/v2/webforms",
    links: "api/v2/links",
    linksCategories: "api/v2/taxonomies/link_categories",
    news: "api/v2/news",
    newsCategories: "api/v2/taxonomies/news",
    podcasts: "api/v2/podcasts",
    polls: "api/v2/polls",
    quiz: "api/quiz",
    training: "api/training",
    videos: "api/v2/videos",
    reactions: "api/v2/reactions",
    search: "api/v2/search",
    contribute: "api/v2/contribution",
    gallery: "api/v2/gallery",
  };

  switch (client) {
    case "radisson":
      resources = { ...resources };
      break;
    case "companyapp":
      resources = { ...resources };
      break;
    case "revo-h":
      resources = { ...resources };
      break;
    case "equans":
      resources = {
        ...resources,
        documentCategories: "api/v2/taxonomies/document_ca",
        linksCategories: "api/v2/taxonomies/external_resource_categories",
        newsCategories: "api/v2/taxonomies/news_categories",
        contribute: "content_submission",
      };
      break;
    default:
      resources = { ...resources };
      break;
  }

  return resources;
};

export const apiEndpoints = endpoints();

export const api = axios.create({
  baseURL: serverUrl,
  withCredentials: true,
  timeout: 3000000, // 30s
  headers: {
    "Content-Type": "application/json",
  },
});
